import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AsmComponentService } from '@spartacus/asm/components';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { AuthService, OCC_USER_ID_ANONYMOUS } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { B2bunitService } from 'src/app/service/b2bunit/b2bunit.service';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../asm-constant';

@Component({
  selector: 'asm-main-ui',
  templateUrl: './asm-main-ui.component.html',
  styleUrls: ['./asm-main-ui.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AsmMainUiComponent implements OnInit {
  customer: any;
  isCustomerEmulationSessionInProgress$: Observable<boolean>;
  subscription = new Subscription();
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  emulatedCompany = '';
  b2bunitEnabled = '';
  constructor(
    protected authService: AuthService,
    private logoutService: LogoutService,
    protected asmAuthService: CsAgentAuthService,
    private componentService: ComponentService,
    protected asmComponentService: AsmComponentService,
    protected userAccountFacade: UserAccountFacade,
    private router: Router,
    private b2bunitService: B2bunitService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.subscription = combineLatest([
      this.userAccountFacade.get(),
      this.componentService.emulatedCustomer$,
      this.isCustomerEmulationSessionInProgress(),
      this.b2bunitService.getShimanoUnitSelectionInfo$(),
    ])
      .pipe(
        tap(([user, emulatedCustomer, isCustomerEmulationSessionInProgress, b2bunitEnabled]) => {
          this.b2bunitEnabled = b2bunitEnabled;
          let selectedCompany = this.storageService.getLocalStorageItem('shimanoSessionB2BUnitname');
          if (selectedCompany) {
            this.emulatedCompany = selectedCompany;
          }
          this.customer = user !== (OCC_USER_ID_ANONYMOUS as string) ? user : emulatedCustomer;
          this.isCustomerEmulationSessionInProgress$ = of(isCustomerEmulationSessionInProgress);
          if (isCustomerEmulationSessionInProgress) {
            this.toggleSalesRepInfoBar('active', true);
          } else {
            if (this.asmEnabled) {
              this.logoutService.logout();
              this.storageService.clearLocalStorageItem();
              this.storageService.setLocalStorageitem(ASM_ENABLED_LOCAL_STORAGE_KEY, 'true');
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate(['login'], { queryParams: { asm: 'true' } });
              });
            } else {
              this.toggleSalesRepInfoBar('d-none', true);
            }
          }
        })
      )
      .subscribe();
  }

  isCustomerEmulationSessionInProgress(): Observable<boolean> {
    return this.asmComponentService.isCustomerEmulationSessionInProgress();
  }

  toggleSalesRepInfoBar(className: string, add: boolean) {
    const salesRepInfoBarEl = document.getElementsByClassName('SalesRepInfoBar')[0] as HTMLElement;
    if (salesRepInfoBarEl) {
      add ? salesRepInfoBarEl.classList.add(className) : salesRepInfoBarEl.classList.remove(className);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
